import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/modules/shared.module';
import { UtilsModule } from '@app/modules/utils.module';
import { SportsComponent } from '@components/sports.component';
import { MaterialImports } from '@environments/environment';
import { CustomFormsModule } from '@app/modules/forms.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreMatchComponent } from '@components/prematch.component';
import { MatchesComponent } from '@components/matches.component';
import { BetStopReasonModule } from '@components/betStopReason/betStopReason.module';
import { EventDetailsModule } from '@components/eventDetails/eventDetails.module';
import { MostPlayedTicketComponent } from '@components/mostPlayedTicket/most-played-ticket.component';
import { FixtureUtilsModule } from '@components/fixture/FixtureUtils.module';
import { LiveComponent } from '../live.components';
import { LiveMatchComponent } from '../livematch.component';
import { StorySliderComponent } from '../story.slider.component';
import { SportLiveMatchComponent } from '../fixture/favorites/sport-live-match.component';
import { LiveEventDetailComponent } from '../liveeventdetail.component';
import { LiveSingleEventList } from '../live-single-eventlist';
import { BestLiveDesktopComponent } from '../best-live-desktop.component';
import { HomeLiveComponent } from '../home-live.components';

@NgModule({
  declarations: [
    LiveComponent,
    LiveMatchComponent,
    StorySliderComponent,
    SportLiveMatchComponent,
    LiveEventDetailComponent,
    LiveSingleEventList,
    HomeLiveComponent,
    BestLiveDesktopComponent,
  ],
  exports: [
    LiveComponent,
    LiveMatchComponent,
    StorySliderComponent,
    SportLiveMatchComponent,
    LiveEventDetailComponent,
    LiveSingleEventList,
    HomeLiveComponent,
    BestLiveDesktopComponent,
  ],
  imports: [
    CommonModule,
    UtilsModule,
    SharedModule,
    MaterialImports,
    RouterModule,
    CustomFormsModule,
    FormsModule,
    BetStopReasonModule,
    EventDetailsModule,
    FixtureUtilsModule,
    ReactiveFormsModule,
  ],
})
export class LiveModule {}
